import Vue from 'vue';
export const linkBus = new Vue();



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/navigation/components/editor-links/link-bus.js